import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard__section"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Pending Invites", -1)
const _hoisted_3 = { class: "button-group" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Accept ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Decline ")
const _hoisted_6 = { class: "dashboard__section" }
const _hoisted_7 = { class: "dashboard__header" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Your Organizations", -1)
const _hoisted_9 = { class: "dashboard__header-button-container" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" New Organization ")
const _hoisted_11 = { class: "table__cell--clickable" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" None yet. Create or join an organization. ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_button = _resolveComponent("loading-button")!
  const _component_organization_card = _resolveComponent("organization-card")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_table_row = _resolveComponent("table-row")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.incomingInvites.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.incomingInvites, (invite) => {
                return (_openBlock(), _createBlock(_component_organization_card, {
                  key: invite.id,
                  "member-count": invite.memberCount,
                  org: invite.organization
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_loading_button, {
                          "button-type": "button--inverted",
                          icon: "check",
                          loading: _ctx.acceptLoading,
                          onClick: ($event: any) => (_ctx.acceptInvite(invite.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]),
                        _createVNode(_component_loading_button, {
                          "button-type": "button--no-bg danger no-margin-top",
                          icon: "times",
                          loading: _ctx.rejectLoading,
                          onClick: ($event: any) => (_ctx.rejectInvite(invite.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_5
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["member-count", "org"]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            class: "dashboard__header-button button--no-bg",
            to: "/dashboard/new"
          }, {
            default: _withCtx(() => [
              _hoisted_10,
              _createVNode(_component_fa_icon, { icon: ['far', 'plus'] })
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("table", null, [
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgs, (org) => {
            return (_openBlock(), _createBlock(_component_organization_card, {
              clickable: true,
              key: org.id,
              "member-count": 5,
              org: org.name,
              onClick: ($event: any) => (_ctx.$router.push(`/dashboard/${org.slug}`))
            }, {
              default: _withCtx(() => [
                _createElementVNode("td", _hoisted_11, [
                  _createVNode(_component_router_link, {
                    class: "table__cell-button",
                    to: `/dashboard/${org.slug}`
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_fa_icon, {
                        class: "high-em text--large",
                        icon: ['far', 'eye']
                      })
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]),
              _: 2
            }, 1032, ["org", "onClick"]))
          }), 128)),
          (_ctx.orgs.length === 0)
            ? (_openBlock(), _createBlock(_component_table_row, { key: 0 }, {
                text: _withCtx(() => [
                  _hoisted_12
                ]),
                buttons: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}